
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'Cpts022',
props: {
hasSlot:{
type:Boolean,
default:true
},
gallery: {
type: Array,
default: []
}
},

directives: {
TransferDom
},
components: {
Previewer,
},
methods: {
showViewer () {
this.$refs.previewer.show(0)
},
}
}
